// extracted by mini-css-extract-plugin
export default {"headerHeight":"115px"};